import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Hero from '../components/Hero';
import AuthorityStrip from '../components/AuthorityStrip';
import ChooseYourJourney from '../components/ChooseYourJourney';
import WhatMakesDifferent from '../components/WhatMakesDifferent';
import ReadRightApproach from '../components/ReadRightApproach';
import LearnToRead from '../components/LearnToRead';
import ReadingMilestones from '../components/ReadingMilestones';
import SmallStepsProgress from '../components/SmallStepsProgress';
import LearnToTeach from '../components/LearnToTeach';
import ForSchools from '../components/ForSchools';
import About from '../components/About';
import Credentials from '../components/Credentials';
import TeamSection from '../components/TeamSection';
import KalahInAction from '../components/KalahInAction';
import PhilosophySection from '../components/PhilosophySection';
import Testimonials from '../components/Testimonials';
import ArticlesSection from '../components/ArticlesSection';
import FAQSection from '../components/FAQSection';
import FinalCTA from '../components/FinalCTA';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import BookTrialButton from '../components/BookTrialButton';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }, [location]);

  return (
    <>
      <Header />
      <main>
        {/* 1. Hero — Building Confident Readers. Empowering Confident Educators. */}
        <Hero />
        {/* 2. Authority Strip — Teacher Kalah credentials */}
        <AuthorityStrip />
        {/* 3. Choose Your Journey — 4 pathways (Children / Parents / Educators / Schools) */}
        <ChooseYourJourney />
        {/* 4. What Makes Read Right Academy Different */}
        <WhatMakesDifferent />
        {/* 5. The Read Right Approach — 6-step methodology */}
        <ReadRightApproach />
        {/* 6. Learn to Read — Age-based pathways (Foundations / Early Readers / School Ready) */}
        <LearnToRead />
        {/* 7. Reading Milestones — what your child will learn */}
        <ReadingMilestones />
        {/* 8. Small Steps, Real Progress — realistic progress stories */}
        <SmallStepsProgress />
        {/* 9. Learn to Teach — educator training */}
        <LearnToTeach />
        {/* 10. For Schools & Institutions */}
        <ForSchools />
        {/* 11. About Teacher Kalah */}
        <About />
        {/* 12. Credentials */}
        <Credentials />
        {/* 13. Team */}
        <TeamSection />
        {/* 14. Kalah in Action */}
        <KalahInAction />
        {/* 15. Philosophy */}
        <PhilosophySection />
        {/* 16. Testimonials */}
        <Testimonials />
        {/* 17. Insights & Articles */}
        <ArticlesSection />
        {/* 18. FAQ */}
        <FAQSection />
        {/* 19. Final CTA */}
        <FinalCTA />
        {/* 20. Contact */}
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <BookTrialButton />
    </>
  );
};

export default Home;
